import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { resetAlert } from '../../../redux/alert';
import {
  Box,
  Button,
  FormControl,
  Modal,
  InputLabel,
  NativeSelect,
  TextField,
  Typography,
  // useMediaQuery,
  Grid,
} from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';
import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import { styled, createTheme } from '@mui/material/styles';
import { orange } from '@mui/material/colors';
import ManageMemberSubComponent from './ManageMemberSubComponent';
import { USER_SERVER, ORGANIZATION_SERVER } from './../../Config';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import axios from 'axios';
axios.defaults.withCredentials = true;

const style2 = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 460,
  bgcolor: 'white',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
  textAlign: 'center',
};

const CustomGrid2 = styled(Grid)({
  minHeight: '64px',
});

const theme = createTheme({
  main: 'rgba(0, 0, 0, 0.6)',
  orange: orange[500],
});

const CustomFormControl = styled(FormControl)({
  '& .MuiInputLabel-root': {
    color: theme.main,
  },
  '& label.Mui-focused': {
    color: theme.orange,
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: theme.orange,
  },
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused fieldset': {
      borderColor: theme.orange,
    },
  },
});

const CustomTextField = styled(TextField)({
  '& .MuiInputLabel-root': {
    color: theme.main,
  },
  '& label.Mui-focused': {
    color: theme.orange,
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: theme.orange,
  },
  '& .MuiOutlinedInput-root': {
    '&.Mui-focused fieldset': {
      borderColor: theme.orange,
    },
  },
});

const validationSchema = Yup.object({
  email: Yup.string('Enter your email'),
  name: Yup.string('Enter your password'),
});

function ManageMemberPage(props) {
  // const navigate = useNavigate();
  const dispatch = useDispatch();
  const [groupList, setGroupList] = useState([]);
  const [userList, setUserList] = useState([]);
  const user = useSelector((state) => state.user.userData);
  const alert = useSelector((state) => state.alert);
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    dispatch(resetAlert());
    setOpen(false);
  };

  const {
    handleSubmit,
    register,
    getValues,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      organization: user?.group || 'None',
      email: '',
      name: '',
    },
    resolver: yupResolver(validationSchema),
  });

  const onSubmit = async (data, e) => {
    // async request which may result error
    try {
      // 조회 조건 param으로 request 요청
      await axios.post(`${process.env.REACT_APP_SERVER}${USER_SERVER}/searchuser`, data).then((res) => {
        // console.log(res);
        setUserList(res.data);
      });
    } catch (e) {
      // handle your error
    }
  };

  useEffect(() => {
    if (user.isAuth) {
      // axios.get(`${process.env.REACT_APP_SERVER}${USER_SERVER}/user`).then((res) => {
      //   setUserList(res.data);
      // });
      let data = {
        organization: user?.role === 'super admin' ? 'All' : user?.group || '',
        email: '',
        name: '',
      };

      axios.post(`${process.env.REACT_APP_SERVER}${USER_SERVER}/searchuser`, data).then((res) => {
        // console.log(res);
        setUserList(res.data);
        setValue('organization', user?.role === 'super admin' ? 'All' : user?.group || '');
      });
      axios.get(`${process.env.REACT_APP_SERVER}${ORGANIZATION_SERVER}/list`).then((res) => {
        // console.log(res.data);
        setGroupList(res.data);
      });
    }
  }, []);

  // user manage modal 닫힐때 현재 search 조건으로 재검색하여 user List update
  const userCahngeCheck = async (state) => {
    if (state) {
      let formData = {
        organization: getValues('organization'),
        email: getValues('email'),
        name: getValues('name'),
      };
      await axios.post(`${process.env.REACT_APP_SERVER}${USER_SERVER}/searchuser`, formData).then((res) => {
        // console.log(res);
        setUserList(res.data);
      });
    }
  };

  useEffect(() => {
    if (alert.alertType === 'registration') {
      setOpen(true);
    }
  }, [alert]);

  return (
    <div className="ManageMemberPage">
      <Grid container sx={{ height: '100%' }}>
        <Grid
          size={{ xs: 12, sm: 3 }}
          sx={{
            height: '100%',
            padding: '16px ',
            backgroundColor: 'white',
          }}
        >
          <Grid container direction="row" justifyContent="center" alignItems="center">
            <CustomGrid2 size={12}>
              <Typography variant="h3" fontSize={24} fontWeight={600} margin={1}>
                Search Member
              </Typography>
            </CustomGrid2>
            <CustomGrid2 size={12}>
              <CustomFormControl type="text" variant="standard" fullWidth sx={{ height: '40px' }}>
                <InputLabel shrink htmlFor="organization">
                  Organization
                </InputLabel>
                <NativeSelect
                  id="organization"
                  fullWidth
                  size="small"
                  {...register('organization')}
                  disabled={user.role !== 'super admin'}
                >
                  <option value={'All'}>Select a Organization...</option>
                  {groupList &&
                    groupList.map((group) => {
                      return (
                        <option key={group._id} value={group._id}>
                          {`${group.name} ${group.projectName ? `- ${group.projectName}` : ''}`}
                        </option>
                      );
                    })}
                </NativeSelect>
              </CustomFormControl>
            </CustomGrid2>
            <CustomGrid2 size={12}>
              <CustomTextField
                fullWidth
                variant="standard"
                label="ID (Email)"
                size="small"
                autoComplete="email"
                sx={{ color: 'red' }}
                slotProps={{
                  htmlInput: {
                    maxLength: 135,
                  },
                }}
                error={Boolean(errors['email'])}
                helperText={Boolean(errors['email']) ? "Doesn't look like a valid email" : ''}
                {...register('email')}
              />
            </CustomGrid2>
            <CustomGrid2 size={12}>
              <CustomTextField
                fullWidth
                variant="standard"
                label="Name"
                size="small"
                autoComplete="name"
                sx={{ color: 'red' }}
                slotProps={{
                  htmlInput: {
                    maxLength: 135,
                  },
                }}
                {...register('name')}
                error={Boolean(errors['name'])}
              />
            </CustomGrid2>

            <Grid size={12} sx={{ textAlign: 'center', height: '100%' }}>
              <Button
                type="submit"
                variant="contained"
                color="error"
                onClick={handleSubmit(onSubmit)}
                fullWidth
                sx={{ height: '100%', fontSize: 20, textTransform: 'none' }}
              >
                <SearchIcon sx={{ fontSize: 32 }} />
                Search
              </Button>
            </Grid>
          </Grid>
        </Grid>

        <Grid
          sx={{
            height: '100%',
            padding: '16px 16px 0px 16px',
            // display: 'inline-flex',
            // flexDirection: 'column',
            overflow: 'hidden',
            overflowY: 'scroll',
          }}
          container
          spacing={3}
          alignContent="flex-start"
          size={{
            xs: 12,
            md: 9,
          }}
        >
          {userList &&
            userList.map((user) => {
              return (
                <Grid
                  key={user._id}
                  size={{
                    xs: 12,
                    md: 4,
                  }}
                >
                  <ManageMemberSubComponent
                    userId={user._id}
                    name={user.name}
                    email={user.email}
                    groupname={user.groupname}
                    role={user.role}
                    phonenumber={user.phonenumber}
                    userCahngeCheck={userCahngeCheck}
                  />
                </Grid>
              );
            })}
        </Grid>
      </Grid>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style2}>
          <CheckCircleOutlineRoundedIcon color="success" style={{ fontSize: 64 }} />
          <Typography id="modal-modal-title" style={{ margin: 16, fontWeight: 600, fontSize: '28px' }}>
            {alert.alertMsg}
          </Typography>
          <Button variant="contained" color="error" size="small" onClick={handleClose}>
            OK
          </Button>
        </Box>
      </Modal>
    </div>
  );
}

export default ManageMemberPage;
